import React, { useContext, useState } from 'react';
import {
  AppBar, Toolbar, Typography, Button, Box, IconButton,
  Drawer, List, ListItem, ListItemButton, ListItemText, Divider,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const AUTH_NAV_ITEMS = [
  { label: 'Dashboard', to: '/dashboard' },
  { label: 'Transacciones', to: '/transactions' },
  { label: 'Categorías', to: '/categories' },
  { label: 'Perfil', to: '/profile' },
];

const PUBLIC_NAV_ITEMS = [
  { label: 'Login', to: '/login' },
  { label: 'Register', to: '/register' },
];

const DRAWER_WIDTH = 260;

const Header = () => {
  const { isAuthenticated, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const navItems = isAuthenticated ? AUTH_NAV_ITEMS : PUBLIC_NAV_ITEMS;

  const handleLogout = () => {
    logout();
    navigate('/');
    setDrawerOpen(false);
  };

  const handleDrawerNav = (to) => {
    navigate(to);
    setDrawerOpen(false);
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography variant="h6" sx={{ flexGrow: 1 }}>
          <Link to="/" style={{ textDecoration: 'none', color: 'inherit' }}>
            Zort
          </Link>
        </Typography>

        {/* Desktop nav */}
        <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 2 }}>
          {navItems.map((item) => (
            <Button
              key={item.to}
              color="inherit"
              component={Link}
              to={item.to}
            >
              {item.label}
            </Button>
          ))}
          {isAuthenticated && (
            <Button color="inherit" onClick={handleLogout}>
              Logout
            </Button>
          )}
        </Box>

        {/* Mobile hamburger */}
        <IconButton
          color="inherit"
          edge="end"
          onClick={() => setDrawerOpen(true)}
          sx={{ display: { xs: 'flex', md: 'none' } }}
        >
          <MenuIcon />
        </IconButton>
      </Toolbar>

      {/* Mobile drawer */}
      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: DRAWER_WIDTH,
            backgroundColor: '#FFFFFF',
            color: 'text.primary',
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 1 }}>
          <IconButton color="inherit" onClick={() => setDrawerOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        <List sx={{ px: 1 }}>
          {navItems.map((item) => (
            <ListItem key={item.to} disablePadding>
              <ListItemButton
                onClick={() => handleDrawerNav(item.to)}
                sx={{
                  borderRadius: 2,
                  mb: 0.5,
                  '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
                }}
              >
                <ListItemText
                  primary={item.label}
                  primaryTypographyProps={{ fontWeight: 600, color: 'text.primary' }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>

        {isAuthenticated && (
          <>
            <Divider sx={{ borderColor: 'divider', mx: 2, my: 1 }} />
            <List sx={{ px: 1 }}>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={handleLogout}
                  sx={{
                    borderRadius: 2,
                    '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' },
                  }}
                >
                  <LogoutIcon sx={{ mr: 1.5, fontSize: 20, color: 'text.primary' }} />
                  <ListItemText
                    primary="Logout"
                    primaryTypographyProps={{ fontWeight: 600, color: 'text.primary' }}
                  />
                </ListItemButton>
              </ListItem>
            </List>
          </>
        )}
      </Drawer>
    </AppBar>
  );
};

export default Header;
